import * as paymentOrderHooks from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder/paymentOrder.hooks";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Card,
  EmptyState,
  Error,
  Loading,
} from "@rentiohq/web-shared/dist/components";
import React from "react";
import CollectionFollowUp from "./CollectionFollowUp";

interface IProps {
  propertyId?: number;
}

export const CollectionFollowUpContainer = (props: IProps) => {
  const { propertyId } = props;

  const {
    missingKYCs: missingKYCsUnsorted,
    isFetching,
    fetchingError: error,
    dispatchMissingKYCs,
  } = paymentOrderHooks.useMissingKYCs(propertyId);

  const missingKYCs = missingKYCsUnsorted?.sort((a, b) => {
    const getActionPriority = (item: typeof a) => {
      // 1: SCA statuses 'NOT_ENROLLED', 'FAILED', or 'REVOKED'
      if (
        item.scaStatus === "NOT_ENROLLED" ||
        item.scaStatus === "FAILED" ||
        item.scaStatus === "REVOKED"
      ) {
        return 0;
      }

      // 2: KYC statuses 'none' or 'failed'
      if (item.status === "none" || item.status === "failed") {
        return 1;
      }

      // All others go last
      return 2;
    };

    const actionA = getActionPriority(a);
    const actionB = getActionPriority(b);

    if (actionA !== actionB) {
      return actionA - actionB;
    }

    // Secondary sort: contact id
    const idA = a.contact?.id ?? 0;
    const idB = b.contact?.id ?? 0;

    return idA - idB;
  });

  const fetchData = (refetch: boolean) => {
    if (isFetching) {
      return;
    }

    if (!refetch) {
      return;
    }

    dispatchMissingKYCs({ propertyId, refetch });
  };

  React.useEffect(() => {
    fetchData(true);
  }, []);

  // TODO: Paging
  // React.useEffect(() => {
  //   if (!!missingKYCs && !isExhausted) {
  //     fetchData(false);
  //   }
  // }, [missingKYCs, isExhausted]);

  const handleRefetch = () => {
    fetchData(true);
  };

  // Render
  if (propertyId) {
    if (!missingKYCs || missingKYCs.length === 0) {
      if (error) {
        return <Error errors={[error]} />;
      }

      return null;
    }

    return (
      <CollectionFollowUp
        items={missingKYCs}
        isFetching={isFetching}
        refetch={handleRefetch}
      />
    );
  }

  if (!missingKYCs) {
    if (isFetching) {
      return <Loading />;
    }

    if (error) {
      return <Error errors={[error]} />;
    }

    return null;
  }

  if (missingKYCs.length === 0) {
    return (
      <Card>
        <EmptyState
          heading={getLocalizedText(
            "payments.collection.follow_up.empty.heading",
          )}
        />
      </Card>
    );
  }

  return (
    <CollectionFollowUp
      items={missingKYCs}
      isFetching={isFetching}
      refetch={handleRefetch}
    />
  );
};
